import API_BASE from "../api";

const normalizeUrl = (value) => String(value || "").trim();

const appendCacheToken = (url, token) => {
  const normalizedToken = String(token || "").trim();
  if (!url || !normalizedToken) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${encodeURIComponent(normalizedToken)}`;
};

export function resolvePostMediaSrc(postOrMediaUrl, resolvedMediaUrl = "") {
  const source =
    postOrMediaUrl && typeof postOrMediaUrl === "object"
      ? {
          mediaUrl: postOrMediaUrl.mediaUrl,
          resolvedMediaUrl: postOrMediaUrl.resolvedMediaUrl,
          cacheToken: postOrMediaUrl._mediaRefreshToken,
        }
      : {
          mediaUrl: postOrMediaUrl,
          resolvedMediaUrl,
          cacheToken: "",
        };
  const preferredUrl = normalizeUrl(source.resolvedMediaUrl);
  const fallbackUrl = normalizeUrl(source.mediaUrl);
  const rawUrl = preferredUrl || fallbackUrl;

  if (!rawUrl) return "";

  const absoluteUrl = /^https?:\/\//i.test(rawUrl)
    ? rawUrl
    : `${API_BASE}${rawUrl}`;

  return appendCacheToken(absoluteUrl, source.cacheToken);
}

export function isVideoPostMediaUrl(mediaUrl, resolvedMediaUrl = "") {
  const candidateUrl = normalizeUrl(mediaUrl || resolvedMediaUrl)
    .split("?")[0]
    .toLowerCase();

  return /\.(mp4|mov|avi|mkv|webm|m4v)$/i.test(candidateUrl);
}

export function isVideoPostMedia(post) {
  return isVideoPostMediaUrl(post?.mediaUrl, post?.resolvedMediaUrl);
}

export function withPostMediaRefreshToken(post, token = Date.now()) {
  if (!post || typeof post !== "object") return post;

  const refreshedPost = {
    ...post,
    _mediaRefreshToken: String(token),
  };

  if (!Object.prototype.hasOwnProperty.call(post, "resolvedMediaUrl")) {
    refreshedPost.resolvedMediaUrl = "";
  }

  if (!Object.prototype.hasOwnProperty.call(post, "videoMetadata")) {
    refreshedPost.videoMetadata = null;
  }

  return refreshedPost;
}
